/*
    Utils to fix antimeridian issues for areas and geometry placed close to or crossing International Date Line.
    for example the Fiji country (and someone else) where antimeridian crosses some islands where this app is used
    It creates undesirable side affect for closest objects placed on different sides of antimeridian or crossing it
    The geometry objects or markers is shown at different sides of the map or with wrong geometry
    the simplest idea is to shift longitude of crossing objects to 180+ degree before sending it to the leaflet
    For Fiji we translate all negative coordinates in bounds of -178 to -180 to positive 180:182 so the objects will be placed at the right side of the map
    and do the inverse transformation when objects is sent to the backend for saving
    for markers see solution: https://gitlab.com/IvanSanchez/Leaflet.RepeatedMarkers
    StarshipTroopers (C) 2021
 */

import * as L from  "leaflet";

export const AMUtil = {
    //area where coordinate longitude should be shifted
    translators: [{
        name: "fiji",
        bounds: [[-19, -180],[-15, -178]],
        lngShift: 360,
    }],

    /**
     * shifts location to longitude and returns the lng shift was made
     * @param l {L.latLng | L.latLngBounds }
     * @param backToCRSBounds {boolean} - 0
     * @returns {number}
     */
    fixLng: function(l, backToCRSBounds = false) {

        let lngShift = 0;
        for (let i in this.translators) {
            let tBounds = L.latLngBounds(this.translators[i].bounds)
            let tShift = this.translators[i].lngShift

            if (backToCRSBounds) {
                let b = this.translators[i].bounds
                tBounds = L.latLngBounds([[b[0][0], b[0][1] + tShift],[b[1][0], b[1][1] + tShift]])
                tShift = tShift * -1
            }
            // L.latLng
            if (typeof l.lat !== "undefined") {
                if (tBounds.contains(l)) {
                    lngShift = tShift;
                    l.lng += lngShift;
                }
                break;
            }

            // L.latLngBounds
            if (typeof l._northEast !== "undefined") {
                if (tBounds.contains(l._northEast) || tBounds.contains(l._southWest)) {
                    lngShift = tShift
                    l._northEast.lng += lngShift;
                    l._southWest.lng += lngShift;
                    break;
                }
            }
        }

        return lngShift;
    },

    /**
     * fixes the vector layer and shift all longitudes of all points if needed
     * in order to avoid possible dateline issue
     * @param leafletLayer
     * @param backToCRSBounds
     * @returns {number}
     */
    fixLayer: function(leafletLayer, backToCRSBounds = false) {
        let lngShift = 0;
        try {
            //polygon || polyline
            let pointArrays = leafletLayer.getLatLngs();
            lngShift = this._transformLatLngs(pointArrays, backToCRSBounds);

            if (lngShift !== 0)
                leafletLayer.setLatLngs(pointArrays);

        } catch (e) {
            //circle || marker
            try {
                let latlng = leafletLayer.getLatLng();
                lngShift = this.fixLng(latlng, backToCRSBounds);
                if (lngShift !== 0)
                    leafletLayer.setLatLng(latlng);
            } catch (e) {

            }
        }
        return lngShift;
    },

    /**
     * transforms all points for latLngs array
     * @param latLngs
     * @param toCRSBounds -
     * @returns {number}
     * @private
     */
    _transformLatLngs: function (latLngs, toCRSBounds) {
        let lngShift = 0;
        //passes the multidimensional array recursively
        if (Array.isArray(latLngs[0])) {
            for (var i = 0; i < latLngs.length; i++) {
                let shift = this._transformLatLngs(latLngs[i], toCRSBounds);
                if ( shift !== lngShift )
                    lngShift = shift;
            }

            return lngShift;
        }

        for (let i in latLngs) {
            let shift = this.fixLng(latLngs[i], toCRSBounds);
            if ( shift !== lngShift )
                lngShift = shift;
        }

        return lngShift;
    }
};
